var render = function render(){var _vm=this,_c=_vm._self._c;return _c('qr-code',{staticClass:"qr_pic",attrs:{"text":_vm.qrCodeSrc,"error-level":"L"}})
}
var staticRenderFns = []

export { render, staticRenderFns }